module.exports = __webpack_public_path__ + "static/media/promo_intro_3.ee6871ad.png";